import { render, staticRenderFns } from "./SpineItem.vue?vue&type=template&id=503c5586&scoped=true&"
import script from "./SpineItem.vue?vue&type=script&lang=js&"
export * from "./SpineItem.vue?vue&type=script&lang=js&"
import style0 from "./SpineItem.vue?vue&type=style&index=0&id=503c5586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c5586",
  null
  
)

export default component.exports